import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SupportingDocument } from '@models/payroll/self-onboarding-document.model';
import { SupportingDocumentType } from '@payroll/types/self-onboarding-document-type.type';

@Component({
    selector: 'app-supporting-documents-upload[document]',
    templateUrl: './supporting-documents-upload.template.html',
})
export class SupportingDocumentsUploadComponent {
    @Input() document!: SupportingDocument;
    @Input() readOnly = true;
    @Output() upload = new EventEmitter<SupportingDocumentType>();

    translationKey(key: 'title' | 'tooltip' | 'criteria'): string {
        return `payroll.setup.supportingDocumentsUploads.${this.document.type}.${key}`;
    }

    getFile(): void {
        this.upload.emit(this.document.type);
    }
}
